import { HomeworkRowProps } from "./type";
import { useLocaleString } from "../../../../../utils/useLocaleString";
import { FColorTypes } from "@fantaskticedtechlimited/fui-colorlib";
import { FIcon, FIconNames } from "@fantaskticedtechlimited/fui-iconlib";
import FListCard from "../../../../../Components/FListCard";
import { Fragment } from "react";
import { FText } from "@fantaskticedtechlimited/fui-complib";

function HomeworkRow(props: HomeworkRowProps) {
	const { homework } = props;
	const ls = useLocaleString();

	return (
		<FListCard
			index={props.index}
			isDisableToolBar={props.isDisableToolbar}
			content={
				<Fragment>
					{/* data in middle top */}
					<FText maxRows={2}>{homework.name}</FText>
					{/* data in middle bottom */}
					{/* status */}
					<FText color={FColorTypes.PRIMARY_GREY} maxRows={1}>
						{homework.courseId}
					</FText>
				</Fragment>
			}
			toolBar={
				<Fragment>
					{/* Button on Right side */}

					{/* More Action button */}
					<FIcon
						name={FIconNames.MORE}
						size="large"
						strokeColor={FColorTypes.PRIMARY_LIGHT}
						onClick={() => {
							props.onMoreActionButtonClick && props.onMoreActionButtonClick();
						}}
					/>
				</Fragment>
			}
		/>
	);
}

export default HomeworkRow;
